import {
  AUDIO_SUB_TYPES,
  BILLING_CYCLE,
  dependMeetingPlanTypeList,
  planTypes,
} from '@/common/constants';
import { defaultMapper, getCartInfo } from "@/common/service/default-mapper"

function getAudioInternationalPlans(planMapJSON) {
  const {
    month_plancode,
    month_amount,
    category,
    tollfree_code_asYouGo,
    quarterly_plancode,
    quarterly_plantype,
    quarterly_amount,
    yearly_plancode,
    yearly_plantype,
    yearly_amount,
    two_years_plancode,
    two_years_plantype,
    two_years_amount,
    three_years_plancode,
    three_years_plantype,
    three_years_amount
  } = planMapJSON.tollfree;

  const plans = [];

  if(month_plancode && month_amount) {
    plans.push({
      type: planTypes.TOLLFREE,
      category,
      plan_code: month_plancode,
      amount: month_amount,
      cartInfo: getCartInfo(),
      billing_cycle: BILLING_CYCLE.MONTHLY,
      supportCoupon: true,
      dependBasePlanTypeList: [...dependMeetingPlanTypeList, planTypes.VIDEO_SDK],
      typeNameKey: 'billing.tollfree.audio_conferencing.title',
      planNameKey: 'billing.tollfree.audio_conferencing.title',
    })
  }
  if(tollfree_code_asYouGo) {
    plans.push({
      type: planTypes.TOLLFREE,
      category,
      plan_code: tollfree_code_asYouGo,
      amount: 0,
      cartInfo: getCartInfo(),
      billing_cycle: BILLING_CYCLE.PAY_AS_YOU_GO,
      supportCoupon: true,
      dependBasePlanTypeList: dependMeetingPlanTypeList,
      typeNameKey: 'billing.tollfree.audio_conferencing.title',
      planNameKey: 'billing.tollfree.audio_conferencing.title',
    })
  }
  if(quarterly_plancode && quarterly_amount) {
    plans.push({
      type: planTypes.TOLLFREE,
      category,
      plan_code: quarterly_plancode,
      plan_type: quarterly_plantype,
      amount: quarterly_amount,
      cartInfo: getCartInfo(),
      billing_cycle: BILLING_CYCLE.QUARTERLY,
      supportCoupon: true,
      dependBasePlanTypeList: [...dependMeetingPlanTypeList, planTypes.VIDEO_SDK],
      typeNameKey: 'billing.tollfree.audio_conferencing.title',
      planNameKey: 'billing.tollfree.audio_conferencing.title',
    })
  }
  if(yearly_plancode && yearly_amount) {
    plans.push({
      type: planTypes.TOLLFREE,
      category,
      plan_code: yearly_plancode,
      plan_type: yearly_plantype,
      amount: yearly_amount,
      cartInfo: getCartInfo(),
      billing_cycle: BILLING_CYCLE.ANNUAL,
      supportCoupon: true,
      dependBasePlanTypeList: [...dependMeetingPlanTypeList, planTypes.VIDEO_SDK],
      typeNameKey: 'billing.tollfree.audio_conferencing.title',
      planNameKey: 'billing.tollfree.audio_conferencing.title',
    })
  }
  if(two_years_plancode && two_years_amount) {
    plans.push({
      type: planTypes.TOLLFREE,
      category,
      plan_code: two_years_plancode,
      plan_type: two_years_plantype,
      amount: two_years_amount,
      cartInfo: getCartInfo(),
      billing_cycle: BILLING_CYCLE.TWO_YEARS,
      supportCoupon: true,
      dependBasePlanTypeList: [...dependMeetingPlanTypeList, planTypes.VIDEO_SDK],
      typeNameKey: 'billing.tollfree.audio_conferencing.title',
      planNameKey: 'billing.tollfree.audio_conferencing.title',
    })
  }
  if(three_years_plancode && three_years_amount) {
    plans.push({
      type: planTypes.TOLLFREE,
      category,
      plan_code: three_years_plancode,
      plan_type: three_years_plantype,
      amount: three_years_amount,
      cartInfo: getCartInfo(),
      billing_cycle: BILLING_CYCLE.THREE_YEARS,
      supportCoupon: true,
      dependBasePlanTypeList: [...dependMeetingPlanTypeList, planTypes.VIDEO_SDK],
      typeNameKey: 'billing.tollfree.audio_conferencing.title',
      planNameKey: 'billing.tollfree.audio_conferencing.title',
    })
  }
  return plans
}

function getUSCAUnlimitedPlans(planMapJSON) {
  return defaultMapper(planMapJSON.tollfreeUnlimited, planTypes.TOLLFREE).map(item => ({
    ...item,
    category: AUDIO_SUB_TYPES.UNLIMITED,
    typeNameKey: 'billing.tollfree.audio_us_ca.title',
    planNameKey: 'billing.tollfree.audio_us_ca.title',
  }))
}

export default (planMapJSON) => {
  return [
    ...getAudioInternationalPlans(planMapJSON),
    ...getUSCAUnlimitedPlans(planMapJSON),
  ]
}
